import { ajax } from 'rxjs/ajax'
import { catchError, finalize } from 'rxjs/operators'
import { requestTracker, generateRequestId } from '../hooks/useRequestTracker'

// Enhanced POST function with request tracking
export const trackedPost = (
  url: string,
  data: any,
  options: object = {},
  local = false,
  baseURL: string,
  requestHeader: () => any,
  handleError: (operation: string) => any,
) => {
  const requestId = generateRequestId()
  requestTracker.addRequest(requestId)

  return ajax({
    headers: requestHeader(),
    method: 'POST',
    withCredentials: false,
    url: `${local ? 'http://localhost/admin/' : baseURL}api/v2${url}`,
    body: data,
    ...options,
  }).pipe(
    catchError(handleError(`${url}`)),
    finalize(() => {
      requestTracker.removeRequest(requestId)
    }),
  )
}

// Enhanced PUT function with request tracking
export const trackedPut = (
  url: string,
  data: any,
  options: object = {},
  local = false,
  baseURL: string,
  requestHeader: () => any,
  handleError: (operation: string) => any,
) => {
  const requestId = generateRequestId()
  requestTracker.addRequest(requestId)

  return ajax({
    headers: requestHeader(),
    method: 'PUT',
    withCredentials: false,
    url: `${local ? 'http://localhost/admin/' : baseURL}api/v2${url}`,
    body: data,
    ...options,
  }).pipe(
    catchError(handleError(`${url}`)),
    finalize(() => {
      requestTracker.removeRequest(requestId)
    }),
  )
}

// Enhanced POST function for main app
export const trackedPostMain = (
  url: string,
  data: object,
  options: object = {},
  local = false,
  getURL: (local: boolean) => string,
  requestHeader: () => any,
  handleError: (operation: string) => any,
) => {
  const requestId = generateRequestId()
  requestTracker.addRequest(requestId)

  return ajax({
    headers: requestHeader(),
    method: 'POST',
    withCredentials: false,
    url: `${getURL(local)}${url}`,
    body: data,
    ...options,
  }).pipe(
    catchError(handleError('post')),
    finalize(() => {
      requestTracker.removeRequest(requestId)
    }),
  )
}

// Enhanced PUT function for main app
export const trackedPutMain = (
  url: string,
  data: object,
  options: object = {},
  local = false,
  getURL: (local: boolean) => string,
  requestHeader: () => any,
  handleError: (operation: string) => any,
) => {
  const requestId = generateRequestId()
  requestTracker.addRequest(requestId)

  return ajax({
    headers: requestHeader(),
    method: 'PUT',
    withCredentials: false,
    url: `${getURL(local)}${url}`,
    body: data,
    ...options,
  }).pipe(
    catchError(handleError('put')),
    finalize(() => {
      requestTracker.removeRequest(requestId)
    }),
  )
}
